<template>
    <div class="video_editor">
        <v-text-field v-model="newData.url" filled maxlength="255" counter="255" :label="dataLabel.url" />
        <v-select v-model="newData.mode" :items="mode" label="Mode d'affichage" />
        <v-switch v-model="newData.enableText" label="Activer le mode icon" />
        <v-text-field v-if="newData.enableText" v-model="newData.text" filled maxlength="255" counter="255"
                      :label="dataLabel.text" />
    </div>
</template>

<script>
    export default {
        name: 'VideoEditor',
        props: {
            value: {
                type: Object,
                default: () => {
                    return {};
                }
            }
        },
        data: () => ({
            dataLabel: {
                url: 'URL de la video...',
                text: 'Saisie du texte...'
            },
            mode: ['Paysage', 'Portrait'],
            newData: {},
            defaultData: {
                url: '',
                enableText: false,
                mode: 'Paysage',
                text: ''
            }
        }),
        watch: {
            newData: {
                handler (newValue) {
                    this.$emit('input', newValue);
                },
                deep: true
            }
        },
        mounted () {
            if (JSON.stringify(this.value) !== '{}') {
                this.newData = { ...this.value };
            } else {
                this.newData = { ...this.defaultData };
            }
        },
        methods: {
            // convertUrl: function (url) {
            //     return url ? this.convertYoutube(url) : '';
            // },
            // convertYoutube: function (url) {
            //     let youtubeRegexp = /https?:\/\/(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube(?:-nocookie)?\.com\S*[^\w\s-])([\w-]{11})(?=[^\w-]|$)(?![?=&+%\w.-]*(?:['"][^<>]*>|<\/a>))[?=&+%\w.-]*/ig;
            //     let id = url.replace(youtubeRegexp, '$1');
            //     if (id.includes(';')) {
            //         const pieces = id.split(';');
            //         if (pieces[1].includes('%')) {
            //             const uriComponent = decodeURIComponent(pieces[1]);
            //             id = `http://youtube.com${uriComponent}`.replace(youtubeRegexp, '$1');
            //         } else {
            //             id = pieces[0];
            //         }
            //     } else if (id.includes('#')) {
            //         id = id.split('#')[0];
            //     }
            //     return 'https://www.youtube.com/embed/' + id;
            // }
        }
    };
</script>

<style scoped>

</style>
